// This file is auto-generated from YAML files in src/data/trips/
// Do not edit this file directly - edit the YAML files instead
// Run 'npm run build:trips' to regenerate this file

export const trips = [
  {
    "id": "egypt-2027",
    "status": "planning",
    "title": "Total Solar Eclipse over the Temple of Luxor: Hidden Tombs, Ancient Pyramids & Old Cairo",
    "subtitle": "Explore pyramids, tombs, and local cuisine with an Egyptologist guide",
    "destination": "Egypt",
    "duration": {
      "days": 10,
      "nights": 9
    },
    "price": {
      "amount": 4825,
      "currency": "USD"
    },
    "heroImage": "photos/egypt-2027/egypt-2027.png",
    "gallery": [
      "https://placehold.co/800x800",
      "https://placehold.co/800x800"
    ],
    "highlights": [
      "Witness a once in a lifetime total solar eclipse from the Temple of Luxor",
      "Explore the sight of the Great Pyramids, the Tomb of Tutankhamun and the temple of Abu Simbel.",
      "Enjoy exclusive after hours access to the Valley of The Kings without the crowds.",
      "Discover the surprising existence of waterfalls, & whale skeletons in the Sahara.",
      "Cruise the Nile in comfort on a traditional wooden Felucca.",
      "Roam the back streets of Old Cairo and go behind the scenes of a goldsmith's studio.",
      "Visit the ancient city of Memphis and the Step Pyramid of Saqqara.",
      "Explore the bustling Khan el-Khalili bazaar for authentic souvenirs and local snacks.",
      "Enjoy a sound and light show at the Pyramids of Giza."
    ],
    "included": [
      "Accommodations throughout the trip",
      "Most meals (as described in the itinerary)",
      "Transportation (as described in the itinerary)",
      "Admission/entry to activities",
      "Special access to places and experiences"
    ],
    "notIncluded": [
      "Flights to and from destination",
      "Pre/Post trip accommodations",
      "Travel insurance",
      "Visas and passport fees",
      "Meals outside of those described"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Arrive Cairo",
        "description": "Salām 'alaykum and welcome to Cairo! If flights line up we will meet at  Cairo Airport and whisk off via private transfer to the hotel in the heart of the city.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Welcome to Egypt!",
        "meals": [
          "Dinner"
        ],
        "accommodation": "Novotel Cairo El Borg or similar, Cairo"
      },
      {
        "day": 2,
        "title": "Explore Giza Plateau",
        "description": "Visit the Great Pyramids of Giza, the Sphinx, and enjoy a camel ride.  In the evening, experience a spectacular sound and light show at the Pyramids.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Great Pyramids of Giza",
        "meals": [
          "Breakfast",
          "Lunch"
        ],
        "accommodation": "Novotel Cairo El Borg or similar, Cairo"
      },
      {
        "day": 3,
        "title": "Day Trip to Saqqara and Memphis",
        "description": "Discover the ancient Step Pyramid of Djoser in Saqqara, and visit the  open-air museum of Memphis, once the capital of ancient Egypt.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Step Pyramid of Djoser",
        "meals": [
          "Breakfast",
          "Lunch"
        ],
        "accommodation": "Novotel Cairo El Borg or similar, Cairo"
      },
      {
        "day": 4,
        "title": "Fly to Luxor",
        "description": "Fly to Luxor and visit Karnak Temple and Luxor Temple. Enjoy dinner overlooking the Nile.",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Karnak Temple",
        "meals": [
          "Breakfast",
          "Dinner"
        ],
        "accommodation": "Steigenberger Nile Palace or similar, Luxor"
      },
      {
        "day": 5,
        "title": "Valley of the Kings & Total Solar Eclipse",
        "description": "Eclipse day! Around midday, time totality from the Theban hills as the total solar eclipse passes directly over Luxor — nearly six minutes of daytime darkness, one of the longest totalities of the 21st century and the whole reason for the trip's timing. Also visit the Valley of the Kings, including the Tomb of Tutankhamun, with exclusive after-hours access. In the evening, relax with a Felucca ride on the Nile.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Valley of the Kings",
        "meals": [
          "Breakfast",
          "Lunch"
        ],
        "accommodation": "Steigenberger Nile Palace or similar, Luxor"
      },
      {
        "day": 6,
        "title": "Abu Simbel Excursion",
        "description": "Take a day trip to the stunning temples of Abu Simbel, built by Ramses II.  Return to Luxor for the night.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Abu Simbel Temples",
        "meals": [
          "Breakfast",
          "Lunch"
        ],
        "accommodation": "Steigenberger Nile Palace or similar, Luxor"
      },
      {
        "day": 7,
        "title": "Travel to Aswan",
        "description": "Travel to Aswan. Visit the Philae Temple dedicated to the goddess Isis  and the Aswan High Dam. Enjoy a local Nubian dinner.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Philae Temple",
        "meals": [
          "Breakfast",
          "Lunch",
          "Dinner"
        ],
        "accommodation": "Mövenpick Resort Aswan or similar, Aswan"
      },
      {
        "day": 8,
        "title": "Nile Cruise Begins",
        "description": "Board a traditional Nile cruise ship and begin your journey down the Nile.  Enjoy on-board activities and relaxation.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Nile Cruise",
        "meals": [
          "Breakfast",
          "Lunch",
          "Dinner"
        ],
        "accommodation": "Nile cruise ship"
      },
      {
        "day": 9,
        "title": "Kom Ombo and Edfu Temples",
        "description": "Stop at Kom Ombo Temple and Edfu Temple, dedicated to the falcon god Horus.  Continue your cruise and enjoy a festive dinner on board.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Kom Ombo Temple",
        "meals": [
          "Breakfast",
          "Lunch",
          "Dinner"
        ],
        "accommodation": "Nile cruise ship"
      },
      {
        "day": 10,
        "title": "Return to Cairo",
        "description": "Disembark in Aswan and fly back to Cairo for your final night. Enjoy a  farewell dinner with your group and reflect on your incredible journey.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Farewell Dinner",
        "meals": [
          "Breakfast",
          "Dinner"
        ],
        "accommodation": "Novotel Cairo El Borg or similar, Cairo"
      }
    ],
    "dates": [
      {
        "startDate": "2027-07-29T00:00:00.000Z",
        "endDate": "2027-08-08T00:00:00.000Z",
        "price": 4825,
        "available": true
      }
    ],
    "activity": "Moderate",
    "groupSize": 5,
    "interest": [
      "History, Culture, Astronomy, & Food"
    ],
    "additionalInfo": {
      "pricing": {
        "deposit": "TBD",
        "depositCurrency": "USD",
        "balanceDueDays": 90,
        "notes": "The price of the trip is per person based on double occupancy.",
        "fullDetails": "Learn more about our pricing and payment plans..."
      },
      "arrivalDeparture": {
        "airport": {
          "code": "CAI",
          "name": "Cairo International Airport"
        },
        "recommendedArrival": "Day 1 before 4:00 PM",
        "recommendedDeparture": "Day 10 after 10:00 AM",
        "notes": "Cairo airport (CAI) connects to a range of flight hubs in North America.",
        "fullDetails": "Detailed arrival and departure information including transfer details..."
      },
      "activityLevel": {
        "level": "Moderate",
        "walkingDistance": {
          "min": 4,
          "max": 6,
          "unit": "miles"
        },
        "notes": "This tour has a moderate activity level. Consider four to six miles of walking  each day, with lots of time spent moving around historical sites.\n",
        "fullDetails": "Complete details about physical requirements and accessibility..."
      },
      "contact": {}
    }
  },
  {
    "id": "uzbekistan-silk-road-2026",
    "status": "planning",
    "title": "Silk Road: Uzbekistan",
    "subtitle": "Rugs, domes, and dunes along the world's most romantic trade route",
    "destination": "Uzbekistan",
    "description": "Seven days through the ancient Silk Road: the walled medieval city of Khiva, a night in the Kyzylkum desert, Bukhara's craft workshops, and Samarkand's Registan Square.\n",
    "duration": {
      "days": 7,
      "nights": 6
    },
    "price": {
      "amount": 0,
      "currency": "USD"
    },
    "heroImage": "photos/uzbekistan-silk-road-2026/uzbekistan-silk-road-2026.jpg",
    "gallery": [
      "photos/uzbekistan-silk-road-2026/map.png"
    ],
    "highlights": [
      "Sleep under the stars in the Kyzylkum desert after a camel trek into the dunes",
      "Wander Khiva's Ichan Kala, a medieval walled city so intact it feels like the 15th century hasn't quite ended",
      "Buy a rug or silk textile in Bukhara's ancient trading domes with a specialist artisan guide",
      "Walk through working carpet and silk workshops behind the tourist-facing storefronts",
      "Stand in Registan Square at dawn, before the tour groups arrive",
      "Travel by private driver across the Kyzylkum desert and Uzbek steppe",
      "Ride the high-speed train from Bukhara to Samarkand through the ancient heartland"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Transit — New York to Khiva",
        "description": "Long travel day. Fly Tashkent, connect to Urgench, transfer by car to Khiva. Check into a riad inside the Ichan Kala walls. The city is quiet at night — worth a walk before the tour groups show up tomorrow.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Khiva Ichan Kala walls at dusk",
        "meals": [
          "Dinner"
        ],
        "accommodation": "Orient Star Khiva or similar, Khiva",
        "location": [
          60.3583,
          41.3775
        ],
        "locationName": "Khiva, Uzbekistan"
      },
      {
        "day": 2,
        "title": "Khiva — The Walled World",
        "description": "Full day inside Ichan Kala. Walk the ramparts, visit the Juma Mosque with its 218 carved wooden columns, climb the Kalta Minor minaret for views over the desert. Khiva is unusually intact — quieter and stranger than most historic cities. Stay out past when the tour groups leave.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Kalta Minor minaret and Ichan Kala rooftops, Khiva",
        "meals": [
          "Breakfast",
          "Dinner"
        ],
        "accommodation": "Orient Star Khiva or similar, Khiva",
        "location": [
          60.3583,
          41.3775
        ],
        "locationName": "Khiva, Uzbekistan",
        "activities": [
          "Ichan Kala UNESCO inner walled city",
          "Juma Mosque — 218 carved wooden columns",
          "Kalta Minor minaret",
          "Islam Khodja minaret and mausoleum"
        ]
      },
      {
        "day": 3,
        "title": "Into the Kyzylkum",
        "description": "Drive from Khiva into the Kyzylkum desert. At the dunes, board a camel and ride to camp. Dinner around a fire. The night sky out here is genuinely dark — zero light pollution. This is the centerpiece of the trip.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Kyzylkum desert dunes at sunset",
        "meals": [
          "Breakfast",
          "Dinner"
        ],
        "accommodation": "Desert dune camp, Kyzylkum Desert",
        "location": [
          58.5,
          41.2
        ],
        "locationName": "Kyzylkum Desert, Uzbekistan",
        "activities": [
          "Camel trek into the dunes",
          "Overnight desert camp",
          "Stargazing — zero light pollution"
        ]
      },
      {
        "day": 4,
        "title": "Desert Sunrise → Bukhara",
        "description": "Up early, watch the sunrise over the dunes, then load up for Bukhara — four to five hours by car through the steppe. Check into a riad in the old city and get oriented. Tomorrow is the main event.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Road through the Uzbek steppe toward Bukhara",
        "meals": [
          "Breakfast",
          "Dinner"
        ],
        "accommodation": "Minzifa Boutique Hotel or similar, Bukhara",
        "location": [
          64.4167,
          39.7667
        ],
        "locationName": "Bukhara, Uzbekistan"
      },
      {
        "day": 5,
        "title": "Bukhara — The Trading Domes",
        "description": "This is the main day. A specialist guide with real relationships in the artisan community takes you behind the tourist-facing shops into working carpet and silk workshops. You watch things being made, ask questions, understand how the pieces are priced, and buy directly from the makers. The trading domes where this happens — Toki Sarrafon and Toki Telpakfurushon — are medieval commercial buildings still being used as markets. What you buy here has a traceable origin.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Bukhara trading dome interior with artisan workshop",
        "meals": [
          "Breakfast",
          "Dinner"
        ],
        "accommodation": "Minzifa Boutique Hotel or similar, Bukhara",
        "location": [
          64.4167,
          39.7667
        ],
        "locationName": "Bukhara, Uzbekistan",
        "activities": [
          "Toki Sarrafon and Toki Telpakfurushon trading domes",
          "Working carpet and silk workshops with specialist guide",
          "Bukhara old city bazaars",
          "Poi Kalon mosque and minaret complex"
        ]
      },
      {
        "day": 6,
        "title": "Bukhara Deep Cut → Evening Train to Samarkand",
        "description": "Slower morning — the Ark citadel, the Lyabi-Hauz pool, the old streets. Time to go back to anything from yesterday or find one last thing at the market. In the evening, take the high-speed train to Samarkand. About ninety minutes.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Lyabi-Hauz pool at dusk, Bukhara",
        "meals": [
          "Breakfast",
          "Dinner"
        ],
        "accommodation": "Antica Dimora or similar, Samarkand",
        "location": [
          66.9597,
          39.6542
        ],
        "locationName": "Samarkand, Uzbekistan",
        "activities": [
          "Ark citadel of Bukhara",
          "Lyabi-Hauz pool and old city",
          "High-speed Afrosiyob train Bukhara → Samarkand"
        ]
      },
      {
        "day": 7,
        "title": "Registan → Home",
        "description": "Registan Square first thing, before the crowds. Three madrassas around a single courtyard — it's big in a way that photos don't capture. The Siab Bazaar after: spices, dried fruit, non bread from tandoor ovens. Then airport transfer and a long flight home.\n",
        "image": "https://placehold.co/800x800",
        "imageAlt": "Registan Square at dawn, Samarkand",
        "meals": [
          "Breakfast"
        ],
        "location": [
          66.9597,
          39.6542
        ],
        "locationName": "Samarkand, Uzbekistan",
        "activities": [
          "Registan Square — Ulugh Beg, Sher-Dor, and Tilya-Kori madrassas",
          "Siab Bazaar",
          "Shah-i-Zinda necropolis (if time allows)"
        ]
      }
    ],
    "dates": [
      {
        "startDate": "2026-09-15T00:00:00.000Z",
        "endDate": "2026-09-21T00:00:00.000Z",
        "price": 0,
        "available": true
      }
    ],
    "activity": "Moderate",
    "groupSize": 4,
    "interest": [
      "History, Culture & Craft"
    ],
    "additionalInfo": {
      "pricing": {
        "deposit": "TBD",
        "depositCurrency": "USD",
        "balanceDueDays": 90,
        "notes": "Price per person. Exact costs TBD pending finalized dates and group size.",
        "fullDetails": "Learn more about our pricing and payment plans..."
      },
      "arrivalDeparture": {
        "airport": {
          "code": "TAS",
          "name": "Tashkent International Airport"
        },
        "recommendedArrival": "Day 1 before 6:00 PM",
        "recommendedDeparture": "Day 7 after 12:00 PM",
        "notes": "Fly into Tashkent (TAS), then connect via domestic flight to Urgench (UGS) — approximately 1.5 hours. Return flights depart from Samarkand (SKD) or connect back through Tashkent. Uzbekistan is currently visa-free for US citizens.\n",
        "fullDetails": "Detailed arrival and departure information..."
      },
      "activityLevel": {
        "level": "Moderate",
        "walkingDistance": {
          "min": 3,
          "max": 6,
          "unit": "miles"
        },
        "notes": "Moderate activity with significant walking on uneven historic surfaces. The desert overnight involves a camel trek of 1–2 hours each way. No technical hiking required. September can still be warm; October is cooler and ideal for comfort.\n",
        "fullDetails": "Complete details about physical requirements and accessibility..."
      },
      "contact": {}
    }
  },
  {
    "id": "catalina-ensenada-cruise-2026",
    "title": "Catalina & Ensenada Cruise Vacation",
    "subtitle": "A 4-night Catalina & Ensenada sailing on Quantum of the Seas, bookended by Seattle",
    "destination": "California & Baja California",
    "duration": {
      "days": 7,
      "nights": 6
    },
    "price": {
      "amount": 0,
      "currency": "USD"
    },
    "heroImage": "photos/catalina-ensenada-cruise-2026/hero.jpg",
    "gallery": [
      "photos/catalina-ensenada-cruise-2026/day5-avalon-1.jpg",
      "photos/catalina-ensenada-cruise-2026/day2-bainbridge-3.jpg"
    ],
    "itinerary": [
      {
        "day": 1,
        "date": "2026-06-27T00:00:00.000Z",
        "title": "JFK → Seattle (Arrive at Pelin's)",
        "description": "Fly JFK → Seattle on Alaska Airlines AS31 (departs 4:29 PM, arrives 8:09 PM). Head to Pelin's place for the night.\n",
        "location": [
          -122.3080159,
          47.4475673
        ],
        "locationName": "Seattle, WA",
        "activities": [
          "Alaska Airlines AS31 — JFK → SEA"
        ],
        "iconIndex": {
          "activities": "Plane"
        }
      },
      {
        "day": 2,
        "date": "2026-06-28T00:00:00.000Z",
        "title": "Seattle — Explore with Pelin (Bainbridge Island?)",
        "description": "Ferry from downtown Seattle (Colman Dock) to Bainbridge Island — a 35-minute ride with gorgeous Puget Sound views — and explore Winslow town. Then visit the Bloedel Reserve, a 150-acre private garden reserve with a Japanese garden, moss garden, and reflection pool.\n",
        "location": [
          -122.5127565,
          47.6234248
        ],
        "locationName": "Bainbridge Island, WA",
        "images": [
          "photos/catalina-ensenada-cruise-2026/day2-bainbridge-1.jpg",
          "photos/catalina-ensenada-cruise-2026/day2-bainbridge-2.jpg",
          "photos/catalina-ensenada-cruise-2026/day2-bainbridge-3.jpg"
        ],
        "activities": [
          "Bainbridge Island ferry & Winslow town",
          "Bloedel Reserve gardens"
        ],
        "iconIndex": {
          "activities": "Ship"
        }
      },
      {
        "day": 3,
        "date": "2026-06-29T00:00:00.000Z",
        "title": "Seattle → LA → Board Quantum of the Seas 🚢",
        "description": "Early flight SEA → LAX on United UA1692 (departs 6:00 AM, arrives 8:44 AM). Transfer to the Los Angeles World Cruise Center in San Pedro and board Royal Caribbean's Quantum of the Seas — Reservation 3871465, Stateroom 11580 (Ocean View Balcony). My Time Dining.\n",
        "location": [
          -118.2775646,
          33.7449169
        ],
        "locationName": "San Pedro (Port of Los Angeles)",
        "images": [
          "photos/catalina-ensenada-cruise-2026/day3-embark-1.jpg",
          "photos/catalina-ensenada-cruise-2026/day3-embark-2.jpg"
        ],
        "activities": [
          "United UA1692 — SEA → LAX",
          "Embark Quantum of the Seas"
        ],
        "iconIndex": {
          "activities": "Ship"
        }
      },
      {
        "day": 4,
        "date": "2026-06-30T00:00:00.000Z",
        "title": "Cruise Day 2 — At Sea / Catalina",
        "description": "At sea aboard Quantum of the Seas. Relax and enjoy the ship.\n",
        "locationName": "At Sea toward Catalina Island"
      },
      {
        "day": 5,
        "date": "2026-07-01T00:00:00.000Z",
        "title": "Cruise Day 3 — Ensenada 🇲🇽 (Avalon Scenic Tour)",
        "description": "Port call at Avalon on Santa Catalina Island. Avalon Scenic Tour (1h 5min) at 8:45 AM.\n",
        "location": [
          -118.3272612,
          33.34221
        ],
        "locationName": "Avalon, Catalina Island",
        "images": [
          "photos/catalina-ensenada-cruise-2026/day5-avalon-1.jpg"
        ],
        "activities": [
          "Avalon Scenic Tour (1h 5min)"
        ],
        "iconIndex": {
          "activities": "Footprints"
        }
      },
      {
        "day": 6,
        "date": "2026-07-02T00:00:00.000Z",
        "title": "Cruise Day 4 — Ensenada 🎨 (Colors of Ensenada)",
        "description": "Port call at Ensenada, Mexico. \"Colors of Ensenada — The Artist Inside You\" shore excursion (5h 15min) at 8:15 AM.\n",
        "location": [
          -116.602983,
          31.8658887
        ],
        "locationName": "Ensenada, Mexico",
        "images": [
          "photos/catalina-ensenada-cruise-2026/day6-ensenada-1.jpg",
          "photos/catalina-ensenada-cruise-2026/day6-ensenada-2.jpg"
        ],
        "activities": [
          "Colors of Ensenada — The Artist Inside You (5h 15min)"
        ],
        "iconIndex": {
          "activities": "Palette"
        }
      },
      {
        "day": 7,
        "date": "2026-07-03T00:00:00.000Z",
        "title": "Disembark LA → JFK (Home!) ✈️",
        "description": "Disembark at the Port of Los Angeles early morning, then fly LAX → JFK on JetBlue B60224 (departs 12:35 PM from Terminal 1, arrives 9:25 PM).\n",
        "location": [
          -73.779317,
          40.639447
        ],
        "locationName": "New York (JFK)",
        "activities": [
          "JetBlue B60224 — LAX → JFK"
        ],
        "iconIndex": {
          "activities": "Plane"
        }
      }
    ],
    "dates": [
      {
        "startDate": "2026-06-27T00:00:00.000Z",
        "endDate": "2026-07-03T00:00:00.000Z",
        "available": false
      }
    ],
    "activity": "Easy",
    "groupSize": 1,
    "interest": [
      "Cruise",
      "Relaxation",
      "Adventure"
    ]
  },
  {
    "id": "puerto-rico-2025",
    "title": "Puerto Rico",
    "subtitle": "Caribbean adventure through rainforests, beaches, and waterfalls",
    "destination": "Puerto Rico",
    "highlights": [
      "Explored Old San Juan & discovered an amazing hidden jazz bar",
      "Watched Dragon Boat Racing at Laguna Condado",
      "Hiked through El Yunque National Forest to multiple waterfalls",
      "Experienced authentic spit-roasted pork on the Pork Highway",
      "Snorkling in Rincón at Black Eagle Beach and Steps Beach"
    ],
    "duration": {
      "days": 5,
      "nights": 4
    },
    "price": {
      "amount": 500,
      "currency": "USD"
    },
    "heroImage": "/photos/puerto-rico-2025/PXL_20250209_163415275.PORTRAIT.jpg",
    "gallery": [
      "/photos/puerto-rico-2025/driving-map.jpg"
    ],
    "routeOverride": [
      [
        -66.049168,
        18.451267
      ],
      [
        -66.1185,
        18.4671
      ],
      [
        -65.771946,
        18.318527
      ],
      [
        -65.770515,
        18.312255
      ],
      [
        -65.777845,
        18.311896
      ],
      [
        -65.728842,
        18.272272
      ],
      [
        -66.103048,
        18.151377
      ],
      [
        -67.2508,
        18.3404
      ],
      [
        -66.983934,
        18.360588
      ],
      [
        -66.049168,
        18.451267
      ]
    ],
    "itinerary": [
      {
        "day": 1,
        "date": "2025-02-07T12:00:00.000Z",
        "title": "Friday: Arrive in Puerto Rico",
        "description": "Landed in San Juan and headed to Old San Juan for an excessivly large  dinner at Cayo Caribe. Explored the streets in the evening rain.\n",
        "location": [
          -66.049168,
          18.451267
        ],
        "locationName": "Old San Juan",
        "accommodation": "Airbnb in San Juan | 2 Nights",
        "meals": [
          "Dinner: Cayo Caribe - Old San Juan"
        ],
        "mealUrls": [
          "https://g.co/kgs/6AMJT5P"
        ],
        "activities": [
          "Evening meander through Old San Juan in the rain"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Utensils",
          "activities": "TreePalm"
        },
        "image": "photos/puerto-rico-2025/PXL_20250208_025815887.NIGHT.jpg"
      },
      {
        "day": 2,
        "date": "2025-02-08T00:00:00.000Z",
        "title": "Saturday: Dragon Boats & Beaches",
        "description": "Full day exploring San Juan's attractions - from watching dragon boat  races to swimming and relaxing at multiple beaches, topped off with an  unexpected discovery of an amazing jazz bar.\n",
        "location": [
          -66.1185,
          18.4671
        ],
        "locationName": "San Juan",
        "accommodation": "Same Airbnb in San Juan | 2nd Night",
        "activities": [
          "Dragon Boat Festival at Public Park Laguna Condado",
          "Swimming at Escambron Beach cove",
          "Relaxing at Playa Ocean Park",
          "Discovered an incredible jazz bar near the Cannon Club"
        ],
        "activityUrls": [
          "https://maps.app.goo.gl/QrPvYdM1RQPH1Aam6",
          "https://maps.app.goo.gl/vEnt6buxBZbPRSa46",
          "https://maps.app.goo.gl/7TZbvvo15PjG73KF7",
          "https://maps.app.goo.gl/3jwsYRAgv6jjsoWRA"
        ],
        "meals": [
          "Breakfast: Lela's Eatery",
          "Lunch: Panuchos",
          "Snack: La Heladería Funkyberry Ice Cream",
          "Dinner: The Cannon Club"
        ],
        "mealUrls": [
          "https://maps.app.goo.gl/AQYNDcZNfC5TFh5u7",
          "https://maps.app.goo.gl/wphKAnzZ5XfgNRh27",
          "https://maps.app.goo.gl/C7jTYBgV1ZVMBi6x5",
          "https://maps.app.goo.gl/3jwsYRAgv6jjsoWRA"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Utensils",
          "activities": "Waves"
        },
        "images": [
          "photos/puerto-rico-2025/PXL_20250208_152704161.jpg",
          "photos/puerto-rico-2025/PXL_20250208_155347803.jpg",
          "photos/puerto-rico-2025/PXL_20250208_200537120.jpg",
          "photos/puerto-rico-2025/PXL_20250208_233642078.MP.jpg"
        ]
      },
      {
        "day": 3,
        "date": "2025-02-09T00:00:00.000Z",
        "title": "Sunday: El Yunque & Pork Highway Adventure",
        "description": "Epic day of waterfall exploration in El Yunque National Rainforest, including  La Coca Falls, Juan Diego Falls and (mis)adventures at Las Tinajas Falls.  Ended the day with authentic spit-roasted pork before the long night drive to Rincón.\n",
        "location": [
          -65.785,
          18.3156
        ],
        "locationName": "El Yunque National Forest",
        "accommodation": "Airbnb in Rincón",
        "activities": [
          "La Coca Falls viewpoint",
          "Torre Yokahú Observation tower",
          "Swimming at Juan Diego Falls",
          "(mis)Adventures at Las Tinajas Falls",
          "Drive along the Pork Highway"
        ],
        "activityUrls": [
          "https://maps.app.goo.gl/vpCzkYCzRwuypNjL8",
          "https://maps.app.goo.gl/nNDHVNvRaLRoVQ8V6",
          "https://maps.app.goo.gl/nZquKisb1cspCxJYA",
          null,
          "https://www.discoverpuertorico.com/rutas-del-lechon-puerto-rico"
        ],
        "meals": [
          "Brunch: Cafe con Ce",
          "Dinner: Lechonera Los Amigos - Authentic spit-roasted pork, rice, beans, and blood sausage"
        ],
        "mealUrls": [
          "https://maps.app.goo.gl/mHfKos9eNwtyumxo8",
          "https://maps.app.goo.gl/HdDFxwJZLh2UnGMW7"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Utensils",
          "activities": "Footprints"
        },
        "images": [
          "photos/puerto-rico-2025/IMG_4978.jpeg",
          "photos/puerto-rico-2025/PXL_20250209_163420293.MP.jpg",
          "photos/puerto-rico-2025/PXL_20250209_164842400.MP.jpg",
          "photos/puerto-rico-2025/PXL_20250209_171235986.MP.jpg",
          "photos/puerto-rico-2025/PXL_20250209_212740584.jpg",
          "photos/puerto-rico-2025/PXL_20250209_221708976.jpg"
        ]
      },
      {
        "day": 4,
        "date": "2025-02-10T00:00:00.000Z",
        "title": "Monday: Rincón Scuba & Cascada Gozalandia",
        "description": "Incredible day of snorkling at multiple beaches in Rincón, seeing colorful  schools of fish (and even a shark). Ended the day jumping off cliffs into  a waterfall pool at Cascada Gozalandia.\n",
        "location": [
          -67.2508,
          18.3404
        ],
        "locationName": "Rincón",
        "accommodation": "Airbnb in San Juan",
        "activities": [
          "Snorkling at Black Eagle Beach (shark sighting!)",
          "Snorkeling among the reef at Steps Beach",
          "Swimming and cliff diving at Cascada Gozalandia"
        ],
        "activityUrls": [
          "https://maps.app.goo.gl/mbszfttmncRGYdFs9",
          "https://maps.app.goo.gl/UV4erCthxNuiGyGd8",
          "https://maps.app.goo.gl/WiMXcnLBEH5P24dm9"
        ],
        "meals": [
          "Breakfast: The Beach House",
          "Lunch: Jack's Shack - Beach taco spot",
          "Late Dinner: Late night tacos in San Juan"
        ],
        "mealUrls": [
          "https://maps.app.goo.gl/etGQaUAs3YRNVJydA",
          "https://maps.app.goo.gl/pWfSzyYAL4ZYcCTa7",
          null
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Utensils",
          "activities": "Waves"
        },
        "images": [
          "photos/puerto-rico-2025/PXL_20250210_125317943.jpg",
          "photos/puerto-rico-2025/PXL_20250210_181349285.jpg",
          "photos/puerto-rico-2025/PXL_20250210_183300144.jpg",
          "photos/puerto-rico-2025/IMG_5037.jpeg",
          "photos/puerto-rico-2025/PXL_20250210_203842988.jpg"
        ]
      },
      {
        "day": 5,
        "date": "2025-02-11T00:00:00.000Z",
        "title": "Tuesday: Return to NYC",
        "description": "Final morning in San Juan with a coffee shop breakfast and beach walk  before a rush to catch our flight.\n",
        "location": [
          -66.049168,
          18.451267
        ],
        "locationName": "San Juan International Airport",
        "meals": [
          "Breakfast: La Coffeetera"
        ],
        "mealUrls": [
          "https://maps.app.goo.gl/nDLpHfKCKAo1xJex8"
        ],
        "activities": [
          "Morning beach walk"
        ]
      }
    ],
    "dates": [
      {
        "startDate": "2025-02-07T00:00:00.000Z",
        "endDate": "2025-02-11T00:00:00.000Z",
        "available": false
      }
    ],
    "activity": "Active",
    "groupSize": 2,
    "interest": [
      "Nature",
      "Adventure",
      "Food"
    ]
  },
  {
    "id": "italy-rome-2024",
    "title": "Italy & Rome 2024",
    "subtitle": "A month in Rome working and exploring the city and surrounding areas",
    "destination": "Italy",
    "duration": {
      "days": 28
    },
    "price": {
      "amount": 7200,
      "currency": "USD"
    },
    "heroImage": "/photos/italy-2024/florence-2024.jpg",
    "gallery": [
      "https://placehold.co/800x800",
      "https://placehold.co/800x800"
    ],
    "itinerary": [
      {
        "day": 1,
        "date": "2024-08-30T00:00:00.000Z",
        "title": "Flight NY - Rome",
        "description": "Fly to Italy.",
        "image": "/photos/italy-2024/PXL_20240830_165131561.jpg"
      },
      {
        "day": 5,
        "date": "2024-09-03T00:00:00.000Z",
        "title": "Municipio Roma I - Rome",
        "description": "",
        "activities": [],
        "image": "/photos/italy-2024/PXL_20240903_101329251.MP~2.jpg"
      },
      {
        "day": 6,
        "date": "2024-09-04T00:00:00.000Z",
        "title": "Temple of Aesculapius - Rome",
        "description": "Exploring the Villa Borghese Park",
        "activities": [
          "Exploring"
        ],
        "image": "/photos/italy-2024/PXL_20240904_121601484.jpg",
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Footprints"
        }
      },
      {
        "day": 8,
        "date": "2024-09-06T00:00:00.000Z",
        "title": "Teatre de Marcel - Rome",
        "description": "Exploring the ancient Theatre of Marcellus and surrounding area",
        "activities": [
          "Walking"
        ],
        "images": [
          "/photos/italy-2024/PXL_20240906_125219050~2(1).jpg",
          "/photos/italy-2024/PXL_20240906_133439718.jpg"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Footprints"
        }
      },
      {
        "day": 14,
        "date": "2024-09-12T00:00:00.000Z",
        "title": "Villa D'Este - Tivoli",
        "description": "",
        "activities": [
          "Walking"
        ],
        "images": [
          "/photos/italy-2024/PXL_20240912_084223800~2.jpg",
          "/photos/italy-2024/PXL_20240912_083421857~2.jpg",
          "/photos/italy-2024/PXL_20240912_084026850.MP.jpg",
          "/photos/italy-2024/PXL_20240912_084329575.MP.jpg"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Footprints"
        }
      },
      {
        "day": 15,
        "date": "2024-09-13T00:00:00.000Z",
        "title": "Vicus Caprarius - The Water City - Rome",
        "description": "Explored an underground Roman aquaduct",
        "activities": [],
        "image": "/photos/italy-2024/PXL_20240913_094551515.MP.jpg"
      },
      {
        "day": 15,
        "date": "2024-09-13T00:00:00.000Z",
        "title": "The Colosseum - Rome",
        "description": "Explored the Colosseum, wandering through the gallery and fighting pit.",
        "activities": [],
        "image": "/photos/italy-2024/PXL_20240913_120833899(1).jpg"
      },
      {
        "day": 15,
        "date": "2024-09-13T00:00:00.000Z",
        "title": "Journey through Ancient Rome - FORO DI CESARE - ROMA",
        "description": "Took a guided tour of the Roman Forum at night",
        "activities": [
          "Walking"
        ],
        "images": [
          "/photos/italy-2024/PXL_20240915_202526909.jpg",
          "/photos/italy-2024/PXL_20240915_202626316.jpg",
          "/photos/italy-2024/PXL_20240915_205800551.jpg"
        ]
      },
      {
        "day": 17,
        "date": "2024-09-15T00:00:00.000Z",
        "title": "Villa Gregoriana - Tivoli",
        "description": "",
        "activities": [
          "Hiking"
        ],
        "images": [
          "/photos/italy-2024/PXL_20240915_080611228.jpg",
          "/photos/italy-2024/PXL_20240915_092715518.jpg"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Footprints"
        }
      },
      {
        "day": 18,
        "date": "2024-09-16T00:00:00.000Z",
        "title": "Quartiere 1 - Florence",
        "description": "",
        "activities": [],
        "images": [
          "/photos/italy-2024/PXL_20240917_073304451.MP~2 (1).jpg",
          "/photos/italy-2024/PXL_20240916_133107902.MP~2.jpg",
          "/photos/italy-2024/PXL_20240916_171151474~2.jpg"
        ]
      },
      {
        "day": 22,
        "date": "2024-09-20T00:00:00.000Z",
        "title": "Appian Way E-bike Tour with Catacombs, Aqueducts & Food",
        "description": "Took an e-bike trip along the Appia Antica, one of the ancient roads around Rome.  We visited the Catacombs of Saint Callixtus, the Mausoleum of Cecilia Metella and  the Villa of Massenzio. We biked the Ancient Roman water lines of the Parco degli  Acquedotti and ended with typical roman aperitive at the Quo Vadis Sporting Club.\n",
        "activities": [
          "Biking"
        ],
        "images": [
          "/photos/italy-2024/PXL_20240920_145942786.jpg",
          "/photos/italy-2024/PXL_20240920_145627165~3(1).jpg",
          "/photos/italy-2024/PXL_20240920_155821161.jpg",
          "/photos/italy-2024/PXL_20240920_161337455.MP.jpg"
        ],
        "iconIndex": {
          "activities": "Bike"
        }
      },
      {
        "day": 24,
        "date": "2024-09-22T00:00:00.000Z",
        "title": "Took trains and a Hydrofoil to Ponza",
        "description": "Took a train to Anzio and then a hydrofoil to Ponza. Ended up staying at a  little BnB on the north tip of the island.\n",
        "activities": [
          "Travel"
        ],
        "images": [
          "/photos/italy-2024/PXL_20240922_120807428.MP.jpg",
          "/photos/italy-2024/PXL_20240922_143859987~2.jpg",
          "/photos/italy-2024/PXL_20240922_154110395.jpg"
        ],
        "iconIndex": {
          "activities": "Ship"
        }
      }
    ],
    "dates": [
      {
        "startDate": "2024-08-30T00:00:00.000Z",
        "endDate": "2024-09-27T00:00:00.000Z",
        "price": 7200,
        "available": false
      }
    ],
    "activity": "Easy",
    "interest": [
      "History, Culture, & Food"
    ]
  },
  {
    "id": "seattle-vancouver-2024",
    "title": "Seattle & Vancouver",
    "subtitle": "Hike through a rainforest with friends",
    "destination": "Seattle",
    "duration": {
      "days": 8,
      "nights": 7
    },
    "price": {
      "amount": 1200,
      "currency": "USD"
    },
    "heroImage": "/photos/seattle-2024/PXL_20240608_201346171.jpg",
    "gallery": [],
    "itinerary": [
      {
        "day": 1,
        "date": "2024-06-02T00:00:00.000Z",
        "title": "Arrive in Seattle",
        "description": "Landed in Seattle",
        "accommodation": "Seattle Airbnb",
        "activities": [
          "Flying"
        ],
        "image": "/photos/Seattle-2024/PXL_20240603_152124315.jpg",
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Plane"
        }
      },
      {
        "day": 2,
        "date": "2024-06-03T00:00:00.000Z",
        "title": "Studio hop",
        "description": "Worked with the Seattle team from the Seattle office and got dinner and drinks with Pelin",
        "activities": [
          "Working"
        ],
        "accommodation": "Seattle Airbnb",
        "image": "/photos/Seattle-2024/PXL_20240603_165123176.PANO.jpg",
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Laptop2"
        }
      },
      {
        "day": 4,
        "date": "2024-06-05T00:00:00.000Z",
        "title": "Explored Fremont",
        "description": "Walked around with Pelin exploring the shops, restaurants and Gas Works park of Fremont",
        "activities": [
          "Walking"
        ],
        "accommodation": "Seattle Airbnb",
        "images": [
          "/photos/Seattle-2024/PXL_20240605_212610391.jpg",
          "/photos/Seattle-2024/PXL_20240605_212129482-EFFECTS.jpg"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Footprints"
        }
      },
      {
        "day": 5,
        "date": "2024-06-06T00:00:00.000Z",
        "title": "Ferry to Victoria",
        "description": "Took the FRS Clipper ferry from Seattle to Victoria, CA to meet up with Andrea.  Searched for nudibranchs under the docks, saw some crazy clouds and went to a concert.\n",
        "activities": [
          "Traveling"
        ],
        "accommodation": "Andrea's couch",
        "images": [
          "/photos/Seattle-2024/PXL_20240606_201105297~2.jpg",
          "/photos/Seattle-2024/PXL_20240606_191606470.MP.jpg"
        ],
        "iconIndex": {
          "accommodation": "House",
          "activities": "Ship"
        }
      },
      {
        "day": 5,
        "date": "2024-06-07T00:00:00.000Z",
        "title": "Explored to Victoria",
        "description": "Biked around Victoria and got some ice cream while Andrea swam. Took the afternoon  ferry to Port Angeles 🧛🏻 to meet back up with Pelin and Patrick.\n",
        "activities": [
          "Traveling"
        ],
        "accommodation": "Port Angeles Airbnb",
        "images": [
          "/photos/Seattle-2024/PXL_20240607_184003086.jpg"
        ],
        "iconIndex": {
          "accommodation": "House",
          "activities": "Bike"
        }
      },
      {
        "day": 7,
        "date": "2024-06-08T00:00:00.000Z",
        "title": "Olympic National Park",
        "description": "Drove to Olympic National Park and hiked through the rainforest with Andrea, Pelin, and Patrick.",
        "activities": [
          "Hiking"
        ],
        "accommodation": "Port Angeles Airbnb",
        "images": [
          "/photos/Seattle-2024/PXL_20240608_171604826.jpg",
          "/photos/Seattle-2024/PXL_20240609_000732192.jpg",
          "/photos/Seattle-2024/PXL_20240608_181756744.MP.jpg",
          "/photos/Seattle-2024/PXL_20240609_032102636~2.jpg"
        ],
        "iconIndex": {
          "accommodation": "House",
          "activities": "Footprints"
        }
      },
      {
        "day": 8,
        "date": "2024-06-09T00:00:00.000Z",
        "title": "Flew to NYC",
        "description": "Drove back to Seattle and caught a plane home to New York",
        "activities": [
          "Traveling"
        ],
        "accommodation": "Home",
        "iconIndex": {
          "accommodation": "Building2",
          "activities": "Plane"
        }
      }
    ],
    "dates": [
      {
        "startDate": "2024-06-02T00:00:00.000Z",
        "endDate": "2024-06-09T00:00:00.000Z",
        "available": false
      }
    ],
    "activity": "Moderate",
    "groupSize": 1,
    "interest": [
      "Nature",
      "Hiking",
      "Adventure",
      "Road Trip"
    ]
  },
  {
    "id": "montreal-eclipse-2024",
    "title": "2024 Total Eclipse in Montreal",
    "subtitle": "Experience the total eclipse and explore Montreal's culture",
    "destination": "Canada",
    "duration": {
      "days": 3,
      "nights": 4
    },
    "price": {
      "amount": 3200,
      "currency": "USD"
    },
    "heroImage": "/photos/eclipse-2024/PXL_20240408_172324899.jpg",
    "gallery": [
      "https://placehold.co/800x800",
      "https://placehold.co/800x800"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Arrive in Montreal",
        "description": "Welcome dinner and evening city tour.",
        "meals": [
          "Dinner"
        ],
        "accommodation": "Montreal downtown hotel"
      }
    ],
    "dates": [
      {
        "startDate": "2024-04-05T00:00:00.000Z",
        "endDate": "2024-04-08T00:00:00.000Z",
        "price": 4825,
        "available": false
      }
    ],
    "activity": "Easy",
    "groupSize": 2,
    "interest": [
      "History, Culture, Astronomy, & Food"
    ]
  },
  {
    "id": "new-zealand-adventure-2023",
    "title": "New Zealand North & South Island Adventure",
    "subtitle": "Urban exploration in Auckland and campervan journey through the South Island",
    "destination": "New Zealand",
    "duration": {
      "days": 46,
      "nights": 45
    },
    "price": {
      "amount": 3200,
      "currency": "USD"
    },
    "heroImage": "/photos/NZ-2023/PXL_20230314_194303657.jpg",
    "gallery": [
      "/photos/NZ-2023/PXL_20230203_215820437.jpg",
      "https://placehold.co/800x800"
    ],
    "itinerary": [
      {
        "day": 1,
        "date": "2023-02-01T00:00:00.000Z",
        "title": "Arrive in Auckland",
        "description": "Land in Auckland and begin New Zealand adventure",
        "accommodation": "Auckland apartment",
        "images": [
          "/photos/NZ-2023/PXL_20230203_215820437.jpg",
          "https://placehold.co/800x600"
        ]
      },
      {
        "day": 6,
        "date": "2023-02-06T00:00:00.000Z",
        "title": "Hobbiton & Rotorua Tour",
        "description": "Guided tour of the famous Hobbiton Movie Set and visit to Rotorua",
        "activities": [
          "Hobbiton Tour",
          "Rotorua Visit"
        ],
        "accommodation": "Auckland apartment",
        "images": [
          "https://placehold.co/800x600",
          "https://placehold.co/800x600"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Coffee",
          "activities": "Bus"
        }
      },
      {
        "day": 9,
        "date": "2023-02-09T00:00:00.000Z",
        "title": "Mission Bay Beach",
        "description": "E-scooter adventure to Mission Bay Beach after work",
        "activities": [
          "E-scooter riding",
          "Beach visit"
        ],
        "image": "https://placehold.co/800x600",
        "accommodation": "Auckland apartment",
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Coffee",
          "activities": "Bike"
        }
      },
      {
        "day": 15,
        "date": "2023-02-15T00:00:00.000Z",
        "title": "Maungauika North Head Historic Reserve",
        "description": "Took a boat to the North Head island and Hiked the mountain and historic fort",
        "activities": [
          "Hiking"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Coffee",
          "activities": "Footprints"
        }
      },
      {
        "day": 25,
        "date": "2023-02-25T00:00:00.000Z",
        "title": "Tapapa Hike",
        "description": "Hiking experience in Tapapa, Waikato region",
        "activities": [
          "Hiking"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Coffee",
          "activities": "Footprints"
        }
      },
      {
        "day": 26,
        "date": "2023-02-26T00:00:00.000Z",
        "title": "Waiheke Island",
        "description": "Day trip to Waiheke Island",
        "activities": [
          "Island exploration"
        ],
        "iconIndex": {
          "accommodation": "Building2",
          "meals": "Coffee",
          "activities": "Ship"
        }
      },
      {
        "day": 27,
        "date": "2023-02-27T00:00:00.000Z",
        "title": "Christchurch",
        "description": "Flew to Christchurch for work and explored the city",
        "duration": "3 days",
        "endDate": "2023-03-01T00:00:00.000Z",
        "accommodation": "Weird pizza hotel",
        "activities": [
          "Work and Flight"
        ],
        "iconIndex": {
          "accommodation": "Building",
          "meals": "Coffee",
          "activities": "Plane"
        }
      },
      {
        "day": 31,
        "date": "2023-03-03T00:00:00.000Z",
        "title": "Queenstown Arrival",
        "description": "Fly to Queenstown",
        "accommodation": "Queenstown hotel",
        "iconIndex": {
          "accommodation": "Building",
          "meals": "Coffee",
          "activities": "Plane"
        }
      },
      {
        "day": 32,
        "date": "2023-03-04T00:00:00.000Z",
        "title": "Queenstown Activities",
        "description": "Experience the Queenstown Skyline Luge",
        "activities": [
          "Skyline Luge"
        ],
        "iconIndex": {
          "accommodation": "Building",
          "meals": "Coffee",
          "activities": "Worm"
        }
      },
      {
        "day": 35,
        "date": "2023-03-07T00:00:00.000Z",
        "title": "Start Campervan Journey & Blue Pools",
        "description": "Pick up camper van and visit the Blue Pools",
        "activities": [
          "Camper van pickup",
          "Blue Pools visit"
        ],
        "accommodation": "Camper van",
        "iconIndex": {
          "accommodation": "Caravan",
          "meals": "Coffee",
          "activities": "Footprints"
        }
      },
      {
        "day": 36,
        "date": "2023-03-08T00:00:00.000Z",
        "title": "Lavender Fields & Mt Sefton",
        "description": "Visit lavender fields and Mt Sefton Glacier",
        "activities": [
          "Lavender field visit",
          "Glacier viewing"
        ]
      },
      {
        "day": 37,
        "date": "2023-03-09T00:00:00.000Z",
        "title": "Arthur's Pass & Motukiekie Beach",
        "description": "Hiking in Arthur's Pass and visit to Motukiekie Beach",
        "activities": [
          "Hiking",
          "Beach visit"
        ]
      },
      {
        "day": 38,
        "date": "2023-03-10T00:00:00.000Z",
        "title": "Punakaiki Pancake Rocks",
        "description": "Visit the famous Pancake Rocks formation",
        "activities": [
          "Geological site visit"
        ]
      },
      {
        "day": 39,
        "date": "2023-03-11T00:00:00.000Z",
        "title": "Arthur's Pass Hiking",
        "description": "Return to Arthur's Pass for more hiking",
        "activities": [
          "Hiking"
        ]
      },
      {
        "day": 41,
        "date": "2023-03-13T00:00:00.000Z",
        "title": "Akaroa",
        "description": "Explore the French-inspired town of Akaroa",
        "activities": [
          "Town exploration"
        ]
      },
      {
        "day": 42,
        "date": "2023-03-14T00:00:00.000Z",
        "title": "Tunnel Beach",
        "description": "Visit the unique Tunnel Beach in Dunedin",
        "activities": [
          "Beach visit"
        ]
      },
      {
        "day": 43,
        "date": "2023-03-15T00:00:00.000Z",
        "title": "Milford Sound",
        "description": "Cruise through the magnificent Milford Sound",
        "activities": [
          "Scenic cruise"
        ]
      },
      {
        "day": 46,
        "date": "2023-03-18T00:00:00.000Z",
        "title": "Queenstown Finale",
        "description": "Final day in Queenstown",
        "accommodation": "Queenstown accommodation"
      }
    ],
    "dates": [
      {
        "startDate": "2023-02-01T00:00:00.000Z",
        "endDate": "2023-03-18T00:00:00.000Z",
        "available": false
      }
    ],
    "activity": "Moderate",
    "groupSize": 1,
    "interest": [
      "Nature",
      "Hiking",
      "Adventure",
      "Cultural Sites",
      "Road Trip"
    ]
  },
  {
    "id": "france-rockclimbing-2024",
    "title": "Rock Climbing Through France",
    "subtitle": "Scaled the cliffs of Normandy, and drove through the rugged terrain of Southern France",
    "destination": "France",
    "duration": {
      "days": 15,
      "nights": 14
    },
    "price": {
      "amount": 3200,
      "currency": "USD"
    },
    "heroImage": "/photos/france-climbing-2017/IMG_2212.JPG",
    "gallery": [
      "https://placehold.co/800x800",
      "https://placehold.co/800x800"
    ],
    "itinerary": [
      {
        "day": 1,
        "title": "Layover in Porto, Portugal",
        "description": "A surprise 12hr layover in Porto tured out to be one of the highlights of the trip.  Locked my bags at the airport and spent the day wandering around the city and ate at  the famous Majestic Cafe where JK Rowlings supposedly wrote parts of Harry Potter.\n",
        "date": "2017-05-20T00:00:00.000Z",
        "images": [
          "photos/france-climbing-2017/IMG_0920.jpg",
          "photos/france-climbing-2017/IMG_0918.jpg"
        ]
      },
      {
        "day": 2,
        "title": "Land in Paris",
        "description": "Meet Ben in Paris early in the morning and crashed at the airBnB. Started the day  with a tour of the Paris catichombs, then walked through the Aarc de Triomphe on  the way to the eiffel tower. Ended the day with a picnic on the lawn of the Eiffel Tower.\n",
        "date": "2017-05-21T00:00:00.000Z",
        "accommodation": "Paris apartment airBnB",
        "images": [
          "photos/france-climbing-2017/IMG_1776.jpg",
          "photos/france-climbing-2017/IMG_1805.jpg",
          "photos/france-climbing-2017/PANO_20170521_172618.jpg",
          "photos/france-climbing-2017/IMG_20170521_183840.jpg"
        ]
      },
      {
        "day": 3,
        "title": "Land in Paris",
        "description": "Headed to a climbing shop (not far from the Louve) to get fitted for gear then  started what turned out to be an 8hr chaotic saga of trying to rent a car and  then drive it through paris 😂. Picked up our stuff from the airBnB and drove to Avon to stay for the night.\n",
        "date": "2017-05-22T00:00:00.000Z",
        "accommodation": "Extra apartment room in Avon (weird vibes)",
        "images": [
          "photos/france-climbing-2017/IMG_1830.jpg",
          "photos/france-climbing-2017/IMG_20170522_120709.jpg",
          "photos/france-climbing-2017/IMG_20170522_120019.jpg"
        ]
      },
      {
        "day": 4,
        "title": "Climbing in Fontainebleau",
        "description": "Hiked into Fontainebleau and bouldered all day. Ended the day in Noisy-sur-Ecole with wine, bread and steak.",
        "date": "2017-05-23T00:00:00.000Z",
        "images": [
          "photos/france-climbing-2017/IMG_20170523_140829.jpg",
          "photos/france-climbing-2017/IMG_20170523_143052.jpg",
          "photos/france-climbing-2017/IMG_20170523_175648.jpg",
          "photos/france-climbing-2017/IMG_20170523_193657.jpg"
        ]
      },
      {
        "day": 4,
        "title": "Climbing in Fontainebleau and driving",
        "description": "Ate a weird breakfast and climbed a bit before hitting the road north to Normandy.",
        "date": "2017-05-24T00:00:00.000Z",
        "images": [
          "photos/france-climbing-2017/IMG_20170524_114124.jpg",
          "photos/france-climbing-2017/IMG_20170524_153926.jpg"
        ]
      },
      {
        "day": 5,
        "title": "Normandy Cliffs",
        "description": "Drove a ton to get up to the cliffs of Normandy. Turned out it was some national  holiday in Normandy which made driving interesting... Hiked up and around the cliff then walked down the beach.\n",
        "date": "2017-05-25T00:00:00.000Z",
        "images": [
          "photos/france-climbing-2017/PANO_20170525_180356.jpg"
        ]
      },
      {
        "day": 6,
        "title": "Mont Saint-Michel",
        "description": "",
        "date": "2017-05-26T00:00:00.000Z",
        "images": [
          "photos/france-climbing-2017/IMG_20170526_131518.jpg",
          "photos/france-climbing-2017/IMG_20170526_131421.jpg",
          "photos/france-climbing-2017/IMG_20170526_144845.jpg",
          "photos/france-climbing-2017/IMG_2034.jpg"
        ]
      }
    ],
    "dates": [
      {
        "startDate": "2017-05-19T00:00:00.000Z",
        "endDate": "2017-06-02T00:00:00.000Z",
        "price": 4825,
        "available": false
      }
    ],
    "activity": "Challenging",
    "groupSize": 2,
    "interest": [
      "History, Culture, Astronomy, & Food"
    ]
  }
];
